import Store from '../../src/redux';
import { sendRequestTarde, sendRequestTardeManger } from './baseRequest';

const getHeaders = () => {
  const user = Store?.getState()?.user;
  return {
    'X-FNOTRADER-SECRET': user?.loginSecret,
    'X-FNOTRADER-USERID': user?.userID,
  };
};

export const createStrategy = (payload) => {
  return sendRequestTardeManger('post', 'strategies', payload, getHeaders());
};

export const updateStrategy = (strategyId, payload) => {
  return sendRequestTardeManger('post', `strategy/${strategyId}`, payload, getHeaders());
};

export const getStrategies = (brokerId) => {
  if(brokerId) {
    return sendRequestTardeManger('get', `strategies?broker_id=${brokerId}`, null, getHeaders());
  }else{
    return sendRequestTardeManger('get', 'strategies', null, getHeaders());
  }
};

export const getStrategy = (strategyId) => {
  return sendRequestTardeManger('get', `strategy/${strategyId}`, null, getHeaders());
};

export const getBasketPositions = (basket_id) => {
  return sendRequestTardeManger('get', `basket/${basket_id}/positions`, {}, getHeaders());
};

export const getBasketOrders = (basket_id) => {
  return sendRequestTardeManger('get', `basket/${basket_id}/orders`, {}, getHeaders());
};

export const getBasketTrades = (basket_id) => {
  return sendRequestTardeManger('get', `basket/${basket_id}/trades`, {}, getHeaders());
};

export const getBasketLogs = (basket_id) => {
  return sendRequestTardeManger('get', `basket/${basket_id}/logs?include_strategy=true`, {}, getHeaders());
};

export const getStrategyPositions = (strategy_id) => {
  return sendRequestTardeManger('get', `strategy/${strategy_id}/positions`, {}, getHeaders());
};

export const getStrategyOrders = (strategy_id) => {
  return sendRequestTardeManger('get', `strategy/${strategy_id}/orders`, {}, getHeaders());
};

export const getStrategyTrades = (strategy_id) => {
  return sendRequestTardeManger('get', `strategy/${strategy_id}/trades`, {}, getHeaders());
};

export const getStrategyLogs = (strategy_id) => {
  return sendRequestTardeManger('get', `strategy/${strategy_id}/logs`, {}, getHeaders());
};

export const squareOffAllPositions = (strategy_id) => {
  return sendRequestTardeManger('post', `strategy/${strategy_id}/squareoff`, {}, getHeaders())
}

export const stopAndExitStrategy = (strategy_id) => {
  return sendRequestTardeManger('post', `strategy/${strategy_id}/stop`, {}, getHeaders())
}

export const deleteStrategy = (strategy_id) => {
  return sendRequestTardeManger('delete', `strategy/${strategy_id}`, null, getHeaders())
}

export const delinkStrategySignal = (strategy_id) => {
  return sendRequestTardeManger('post', `strategy/${strategy_id}/delink-signals`, {}, getHeaders())
}

export const linkStrategySignal = (strategy_id) => {
  return sendRequestTardeManger('post', `strategy/${strategy_id}/link-signals`, {}, getHeaders())
}




